import { isProduction, isDev } from 'common/utils/environment-utils';

export const getGFBLoginLink = () => {
  if (isDev()) return 'https://ge-web-booking.grab.dev/book/login';

  return isProduction()
    ? 'https://express.grab.com/book/login'
    : 'https://express.stg-myteksi.com/book/login';
};

export const getGrabIDLoginLink = () => {
  if (isDev())
    return 'https://ge-web-booking.grab.dev/book/login?method=grabId';

  return isProduction()
    ? 'https://express.grab.com/book/login?method=grabId'
    : 'https://express.stg-myteksi.com/book/login?method=grabId';
};
